import { AcpLogo, BackSvg } from '../../../../CommonComponents/svgs/Svgs'
import useModal from '../../hooks/useModal'
import './ScenarioHeader.scss'

const ScenarioHeader = () => {
    const { onCloseScenario } = useModal()
    return (
        <div className='scenario__header'>
            <button className='logo__container'
                onClick={() => onCloseScenario('Home')}
            >
                <AcpLogo />
            </button>
            <button className='home__button__container'
                onClick={() => onCloseScenario('Dashboard')}
            >
                <BackSvg />
            </button>
        </div>
    )
}

export default ScenarioHeader